export default defineNuxtRouteMiddleware(async (to, from) => {
  const maintMode = await isMaintenanceMode();
  if (maintMode)
    throw createError({ statusCode: 500, message: "error.maintenanceEnabled", fatal: true, unhandled: false });
});
